<template>
  <div class="app-change-evn">
    <EvnSelect :evn-selected.sync="evnSelected">
      <template v-for="slot in possibleChildSlotsFor('Select')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </EvnSelect>
    <Stepper
      @next="next()"
      :loading-next="loadingNext"
      @prev="prev()"
      :loading-prev="loadingPrev"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>
import Stepper from '../../../generic/Stepper.vue'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import { stepName as nextStep } from './Success.vue'
import { stepName as prevStep } from './Current.vue'
import processSteps from '@/mixins/processSteps'
import preFilledInput from '@/mixins/preFilledInput'
import EvnSelect from '@/components/process/generic/ItemisedBills/Select.vue'
import slotProxy from '@/mixins/slotProxy'

export const stepName = 'change'
export default {
  name: 'Change',
  components: { EvnSelect, Stepper },
  computed: {
    ...mapGetters('evn', [
      'getCurrentEvn'
    ]),
    storedEvnSetting () {
      return this.getCurrentEvn?.evn
    }
  },
  mixins: [
    processSteps(prevStep, stepName, nextStep),
    preFilledInput('evnSelected', 'storedEvnSetting'),
    slotProxy()
  ],
  methods: {
    ...mapActions('evn', [
      'saveEvnSettings'
    ]),
    ...mapMutations('evn', [
      'changeStep'
    ]),
    async next () {
      this.loadingNext = true
      await this.saveEvnSettings({ selectedEvn: this.evnSelected, nextStep: nextStep })
      this.loadingNext = false
    },
    async prev () {
      this.loadingPrev = true
      await this.changeStep(prevStep)
      this.loadingPrev = false
    }
  },
  data () {
    return {
      loadingNext: false,
      loadingPrev: false
    }
  }
}
</script>
